import { Widget } from '@modules/widget';

export const HomePage = () => {
    return <Widget />;
};
